<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="hlf"></a><a id="page_i"></a>The New American Economy<a id="page_ii"></a></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230249226_01_hlf.vue?3c1311d4